import React, { ReactNode, useContext } from 'react';
import { Card, Divider, Row, Col } from 'antd';
import { ConfigContext } from '../../context/Config';
import Text from '../Text';
import Wrapper from '../Wrapper';
import './NewImageGroupCard.less';

export type NewImageGroupCardProps = {
  image?: string;
  cover?: ReactNode;
  dotMenu?: ReactNode | null;
  performanceStatus?: ReactNode | null;
  attendanceStatus?: ReactNode | null;
  coverHeight?: any;
  coverWidth?: any;
  onClick?: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

const TNewImageGroupCard: React.FC<NewImageGroupCardProps> = ({
  children,
  image,
  coverHeight,
  coverWidth,
  cover,
  dotMenu,
  performanceStatus,
  attendanceStatus,
  ...props
}) => {
  const { translate } = useContext(ConfigContext);

  const renderPerformanceStatus = () => {
    return (
      <span className="t-groupCardPerformanceStatus">
        <Text rows={1} semiBold level={2}>
          {translate('Performance')}
        </Text>
        {performanceStatus}
      </span>
    );
  };

  const renderAttendanceStatus = () => {
    return (
      <span className="t-groupCardAttendanceStatus">
        <Text rows={1} semiBold level={2}>
          {translate('Attendance')}
        </Text>
        {attendanceStatus}
      </span>
    );
  };

  const renderDivider = () => {
    return <Divider type="vertical" className="t-spliter" />;
  };

  // const coverColProps = {
  //   xs: 24,
  //   sm: 10,
  //   md: 10,
  //   lg: 10,
  //   xl: 8,
  //   xxl: 8,
  // };

  // const descriptionColProps = {
  //   xs: 24,
  //   sm: 14,
  //   md: 14,
  //   lg: 14,
  //   xl: 15,
  //   xxl: 15,
  // };

  // const dotMenuColProps = {
  //   xs: 1,
  //   sm: 1,
  //   md: 1,
  //   lg: 1,
  //   xl: 1,
  //   xxl: 1,
  // };

  return (
    <Card
      className="t-newImageGroupCardContainer"
      // cover={dotMenu}
      // actions={[
      //   <span className="t-groupCardPerformanceStatus">{performanceStatus}</span>,
      //   <span className="t-groupCardAttendanceStatus">{attendanceStatus}</span>,
      // ]}
    >
      <Wrapper>
        <Row gutter={[12, 12]} align="middle">
          <Col span={24}>
            {!cover && !!image ? (
              <div className="t-newImageGroupCardCoverImgWrapper">
                <img
                  src={image}
                  style={{ height: coverHeight, width: coverWidth }}
                  className="t-newImageGroupCardCoverImg"
                  alt="group_card_cover"
                />
              </div>
            ) : (
              <div style={{ height: coverHeight, width: coverWidth }}>
                {cover}
              </div>
            )}
          </Col>
          <Col span={24}>{children}</Col>
          {/* <Col {...dotMenuColProps}>{dotMenu}</Col> */}
        </Row>

        <Divider type="horizontal" className="t-divider" />

        {/* Performance and Attendance progress bar */}
        <div className="t-actionsStatus">
          {performanceStatus && renderPerformanceStatus()}
          {!!attendanceStatus && !!performanceStatus && renderDivider()}
          {attendanceStatus && renderAttendanceStatus()}
        </div>
      </Wrapper>
    </Card>
  );
};

export default TNewImageGroupCard;
